export default "__VITE_ASSET__B_ma5UxQ__"